type ShareItemProps = {
  onClick: () => void;
  Icon: any;
  name: string;
};

const ShareItem = (props: ShareItemProps) => {
  return (
    <div className="flex flex-col cursor-pointer items-center" onClick={props.onClick}>
      <div className="bg-gray-300 w-15 h-15 flex items-center justify-center rounded-full mb-2 p-3">{props.Icon}</div>
      <p className="text-white">{props.name}</p>
    </div>
  );
};

export default ShareItem;
